import queryString from "query-string";
import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

type SearchParameterValue = string | number | boolean | undefined;

interface SetSearchParamsOptions {
  shouldReplace?: boolean;
}

export function useSetSearchParams() {
  const history = useHistory();
  const location = useLocation();

  return useCallback(
    (params: Record<string, SearchParameterValue> = {}, options: SetSearchParamsOptions = {}) => {
      const search = queryString.stringify({
        ...queryString.parse(location.search),
        ...params,
      });

      if (options.shouldReplace) {
        history.replace({ search });
      } else {
        history.push({ search });
      }
    },
    [history, location.search]
  );
}
